import { fetchNodesTimeseriesRawDataForDashboard } from "../api/timeseries/fetch-nodes-timeseries-raw-data-for-dashboard";
import { fetchNodesTimeseriesRawDataForDashboardWithLastAvailableTimestamp } from "../api/timeseries/fetch-nodes-timeseries-raw-data-with-last-available-timestamp";
import { Tile } from "../blueprint/dashboards/entities/tile";

export const getTimeseriesRawDataForDashboard = async (
  groupId,
  tile: Tile,
  lookForLastAvailableTimeStampBeforeFetchingData = false,
  signal?: AbortSignal,
) => {
  if (lookForLastAvailableTimeStampBeforeFetchingData) {
    return await fetchNodesTimeseriesRawDataForDashboardWithLastAvailableTimestamp(
      groupId,
      tile.getTimePeriod(),
      tile.getNodes(),
      signal,
    );
  } else {
    return await fetchNodesTimeseriesRawDataForDashboard(
      groupId,
      tile.getTimePeriod(),
      tile.getNodes(),
      signal,
    );
  }
};
